import {WlButton} from "./button.component";

export * from './button.component';
export default WlButton;

customElements.define('wl-button', WlButton);